import React, { useCallback, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { createGlobalStyle } from 'styled-components';
import { useLocation } from 'react-router-dom';
import { isDesktop, isTablet } from 'react-device-detect';

// import { data, data2, data3 } from '../../utils/test/worksheet';
import WorksheetHeader from './WorksheetHeader';
import WorksheetItem from './WorksheetItem';

import { getParam } from '../../utils/utilityEtc';
import { worksheetListSelAPI, qrWorksheetListSelAPI } from '../../api/globalAPI';
import { useAlert, useLaTexCode } from '../../hooks';
import moment from 'moment';

const GlobalStyle = createGlobalStyle`
  // mjx-container {
  //   font-size: small !important;
  // }
  // .pv-ib {
  //   margin-top: 8px
  // }

`;

function WorkSheetPage() {

  const location = useLocation();
  const urlParams = useRef();
  const [workSheet, setWorkSheet] = useState(null);
  const [lrnInfo, setLrnInfo] = useState(null);
  const [, CodeAlert] = useAlert();
  const { getEndScope } = useLaTexCode();

  useEffect(() => {
    const { search } = location;
    if (!search) return;
    const params = getParam(decodeURIComponent(location.search));

    if (params?.stgCd) workSheetListAPISelCall(params);
    else qrWorksheetListSelAPICall(params);
  }, [location]);

  // useEffect(() => {
  //   if (!workSheet) return;

  //   setTimeout(() => {
  //     const dom = document.getElementsByTagName('mjx-box');
  //     console.log(dom);
  //     if (!dom || dom.length === 0) return;

  //     for(let i = 0; i < dom.length; i++) {
  //       dom[i].classList.add('active-bd');
  //     };
  //   })
  // }, [workSheet])

  const workSheetListAPISelCall = useCallback(async (params) => {
    localStorage.setItem('locale', params.langCd);
    try {
      const resp = await worksheetListSelAPI({
        lrnMbrId: params.lrnMbrId,
        langCd: params.langCd,
        stgCd: params.stgCd,
      });

      if (resp.code !== 'S000000') {
        CodeAlert(resp);
      }
      
      dataProcess(resp.data, params)
    } catch (error) {
      console.log("##### workSheetListAPISel error: ", error);
    }
  }, []);
  
  const qrWorksheetListSelAPICall = useCallback(async (params) => {
    try {
      const resp = await qrWorksheetListSelAPI({
        lrnMbrId: params.lrnMbrId,
        langCd: params.langCd,
        qstCdList: params.qstCds,
      });

      if (resp.code !== 'S000000') {
        CodeAlert(resp);
      }
      dataProcess(resp.data.qstList, params)
      setLrnInfo(resp.data.lrnInfo);
    } catch (error) {
      console.log("##### workSheetListAPISel error: ", error);
    }
  }, [])


  const dataProcess = useCallback((data, params) => {
    let qstCds = '';

    if (params?.type !== 'qrcode') {
      
      
      data.forEach((item) => {
        const temp = item.qstCn.split(`inputArea`);
        let qstCn = '';
        temp.forEach((q, index, origin) => {
          const cssId = `${'answerArea'}${index}}{`;
          if (index === 0) {
            qstCn = `${q}${cssId}`;
          } else {
            const scopeStartValue = q.slice(q.indexOf('{'));
            const scopeEndPoint = getEndScope(scopeStartValue);
            const qstCransr = item.qstCransr.split(';');

            qstCn = qstCn.concat(
              `\\phantom{${qstCransr.length === 1 ? qstCransr : qstCransr[index - 1]}}`
              + `${scopeStartValue.slice(scopeEndPoint - 1)}${origin.length === index + 1 ? '' : cssId}`
            )
          }
        })
        item.qstCn = qstCn;
        qstCds = qstCds.concat(item.qstCd, ';');
      });
  
    } 
    
    urlParams.current = {
      ...params,
      regDate: params.stgCd ? moment(new Date()).format('YY/MM/DD') : '',
      qstCds: qstCds ? qstCds : params.qstCds
    };
    setWorkSheet(data);

  }, [])

  if (!workSheet) return (
    <div className='loading_layer'>
      <div className="spinner">
        <div className="lds-spinner">
          <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
        </div>
      </div>
    </div>
  );

  return (
    <div className="worksheet">
      <GlobalStyle />
      <WorksheetHeader 
        urlParams={urlParams}
        lrnInfo={lrnInfo}
        stgCd={workSheet[0]?.stgCd}
      />
      <div className="container">
        <section>
          <div className="worksheet_wrap">
            <p className="sub_txt">{workSheet[0]?.stgNm}</p>
            <p className="sub_tit">{workSheet[0]?.textCn}</p>
            <div 
              className={clsx(
                (isTablet || isDesktop) && 'flx_area'
              )}
            >
              <div className="mathExp-wrap">
                <div className="mathExp-inner">  
                  {/* <div className="mathExt on"> */}
                  <ul className="qst_lst">
                    {
                      workSheet.filter((v, i) => i < 5).map((q, index) => (
                        <WorksheetItem
                          index={index + 1}
                          key={q.qstCd}
                          item={q}
                        />
                      ))
                    }
                  </ul>
                  <ul className="qst_lst">
                    {
                      workSheet.filter((v, i) => i >= 5).map((q, index) => (
                        <WorksheetItem
                          index={index + 6}
                          key={q.qstCd}
                          item={q}
                        />
                      ))
                    }
                  </ul>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    // <React.Fragment>
    //   <GlobalStyle />
    //   <div
    //     style={{
    //       flexWrap: 'wrap',
    //       flexDirection: 'space-evenly',
    //       display: 'flex',
    //       justifyContent: 'space-evenly',
    //       alignItems: 'center',
    //       padding: '60px 0'
    //     }}
    //   >
    //     <div>
    //       <button
    //         type='button'
    //         className="btn_white"
    //       >
    //         Email
    //       </button>
    //       <button 
    //         type='button' 
    //         className="btn_white"
    //         style={{marginLeft: 10}}
    //         onClick={handlePrint}
    //       >
    //         Print
    //       </button>
    //     </div>
    //     <QRCode 
    //       value="https://dev-brs-fo-frontend.wjtb.kr/worksheet"
    //     />
    //   </div>
    //   <div style={{
    //     flexWrap: 'wrap',
    //     flexDirection: 'space-evenly',
    //     display: 'flex',
    //     justifyContent: 'flex-start',
    //     alignItems: 'flex-start',
    //     padding: '60px 0'
    //   }}>
    //     <div style={{padding: '0 30px'}}>
    
    //     </div>
    //     <div style={{ padding: '0 30px' }}>
          
    //     </div>
    //   </div>
    // </React.Fragment>
  );
}

export default WorkSheetPage;

